var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18784_2500",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4974 16.0827C9.42777 16.0839 10.3492 15.9012 11.2088 15.5452C12.0683 15.1891 12.849 14.6667 13.506 14.008C14.1648 13.351 14.6872 12.5703 15.0432 11.7107C15.3993 10.8512 15.5819 9.92973 15.5807 8.99935C15.5819 8.06899 15.3992 7.14755 15.0432 6.28801C14.6871 5.42846 14.1648 4.64775 13.506 3.99073C12.849 3.33199 12.0683 2.80958 11.2088 2.45354C10.3492 2.09749 9.42777 1.91482 8.4974 1.91602C7.56703 1.91484 6.6456 2.09752 5.78605 2.45356C4.92651 2.80961 4.14579 3.33201 3.48878 3.99073C2.83005 4.64775 2.30766 5.42846 1.95161 6.28801C1.59556 7.14755 1.41288 8.06899 1.41407 8.99935C1.41286 9.92973 1.59553 10.8512 1.95158 11.7107C2.30763 12.5703 2.83004 13.351 3.48878 14.008C4.14579 14.6667 4.92651 15.1891 5.78605 15.5451C6.6456 15.9012 7.56703 16.0839 8.4974 16.0827Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.08333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66406 8.99902L7.78906 11.124L12.0391 6.87402",
    stroke: "black",
    strokeWidth: 1.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18784_2500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H17V17.5H0V0.5Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.a080b49e5767344014d6e1809af23b28.svg";
export { ForwardRef as ReactComponent };